// To add new case:
// 1. Create a new object here with case info.
// 2. Update 'images' in index.js with case image
export default {
  projects: [
    {
      name: "Safello",
      idName: "safello",
      content: {
        headline: "Safello",
        description: "Java / Spring Boot · AWS · TypeScript · Docker",
      },
      headline: {
        name: "Safello",
        description: "Senior Backend Engineer at Sweden's largest crypto exchange",
      },
      info: [
        "Senior Backend Engineer, 2021 – present",
        "Listed on Nasdaq First North, Sweden's largest crypto exchange",
        "Own the exchange, compliance and payment backends across multiple services",
        "Remote team of 4 — most senior engineer on the backend side",
      ],
      learnings: [
        "KYC/KYB, AML and EU travel-rule compliance systems built from scratch",
        "Crypto exchange operations — Fireblocks custody, deposit/withdrawal flows, order lifecycle",
        "Handling production incidents when real money is on the line",
        "Payment reconciliation and working closely with finance and accounting",
      ],
      imgName: "safello.png",
      links: {
        github: "https://github.com/Safello",
        website: "https://safello.com/",
      },
    },
    {
      name: "Peblett",
      idName: "peblett",
      content: {
        headline: "Peblett",
        description: "React, Web3.js, Ethereum",
      },
      headline: {
        name: "Peblett",
        description: "Built it to understand how Ethereum wallets actually work",
      },
      info: [
        "Built in 2021 when I joined Safello",
        "Wanted to go deeper than just using MetaMask — key generation, signing transactions, talking to the network",
        "React frontend, Web3.js for everything on-chain",
      ],
      learnings: [
        "How wallets actually work under the hood",
        "Web3.js and interacting directly with the Ethereum network",
        "Blockchain key generation and address derivation",
      ],
      imgName: "peblett.png",
      links: {
        github: "https://github.com/kol845/peblett",
        website: "https://priceless-bohr-0720c0.netlify.app/",
      },
    },
    {
      name: "Necro",
      idName: "necro",
      content: {
        headline: "Necro",
        description: "Godot game engine, GDScript",
      },
      headline: {
        name: "Necro",
        description: "A puzzle-platformer game — playable in the browser",
      },
      info: [
        "Built during Hyper Island in 2021",
        "Wanted to understand game loops and collision mechanics from scratch",
        "Picked Godot, built something I actually finished and shipped",
      ],
      learnings: [
        "Godot game engine and GDScript",
        "Game mechanics — gravity, collision detection, level design",
        "Shipping something fully playable rather than leaving it half-done",
      ],
      imgName: "necro.png",
      links: {
        github: "https://github.com/kol845/necro",
        website: "https://loving-jennings-8f403c.netlify.app/",
      },
    },
    {
      name: "FakeNews",
      idName: "fakenews",
      content: {
        headline: "FakeNews",
        description: "React, Gatsby, PHP backend, GPT-3",
      },
      headline: {
        name: "FakeNews",
        description: "AI-generated news site — built in 2021 before anyone called it that",
      },
      info: [
        "Got curious what GPT-3 could actually produce and built around it",
        "Full CMS so I could add and remove articles without touching the code",
        "React / Gatsby frontend, PHP backend",
      ],
      learnings: [
        "Playing with LLM APIs before they went mainstream",
        "Building a CMS from scratch",
        "Running a separate frontend and backend repo on the same project",
      ],
      imgName: "gotm.png",
      links: {
        github: "https://github.com/kol845/fake-news",
        github2: "https://github.com/kol845/fake-news-backend",
        website: "https://gifted-dijkstra-b5bb7b.netlify.app/",
      },
    },
    {
      name: "Gotm",
      idName: "gotm",
      content: {
        headline: "Gotm",
        description: "UI/UX Design, Figma",
      },
      headline: {
        name: "Gotm",
        description: "UI/UX design for gotm.io — a gaming platform by Macaroni Studios",
      },
      info: [
        "Freelance job for Macaroni Studios",
        "Designed the UI/UX for gotm.io, their game hosting platform",
        "Figma — design, prototyping and presenting to the client",
      ],
      learnings: [
        "UI/UX design and Figma",
        "Presenting work to and taking feedback from a real client",
        "User research and translating it into design decisions",
      ],
      imgName: "gotm.png",
      links: {},
    },
    {
      name: "Crypto Vs Wallstreet",
      idName: "crypto_vs_wallstreet",
      content: {
        headline: "Crypto Vs Wallstreet",
        description: "React, public market APIs",
      },
      headline: {
        name: "Crypto Vs Wallstreet",
        description: "Kept switching tabs during the 2020 surge — so I built this instead",
      },
      info: [
        "Built in 2020 during the big crypto rally",
        "Wanted both markets side by side in real time without switching between tabs",
        "React frontend pulling from public crypto and stock APIs",
      ],
      learnings: [
        "Working with multiple external APIs and combining the data",
        "Charting libraries and real-time data display",
        "Deploying to Netlify",
      ],
      imgName: "cryptoVsWallstreet.png",
      links: {
        github: "https://github.com/StockVsCrypto/crypto-vs-wallstreet",
        website: "https://trusting-fermi-b3ac93.netlify.app/",
      },
    },
    {
      name: "Future Key",
      idName: "future_key",
      content: {
        headline: "Future Key",
        description: "Vanilla JS, Express, mail API",
      },
      headline: {
        name: "Future Key",
        description: "Lock a password and have it emailed to you in the future",
      },
      info: [
        "Built during Hyper Island",
        "You enter a password, pick a date, and it gets sent to your email then — not before",
        "Vanilla JS frontend, Express + SQLite backend, nodemailer for sending",
      ],
      learnings: [
        "Scheduling tasks with cron jobs",
        "Sending emails programmatically with nodemailer",
        "Building a small but complete full-stack app with no frameworks",
      ],
      imgName: "futurekey.png",
      links: {
        github: "https://github.com/kol845/futurekey",
      },
    },
    {
      name: "Daily Habits",
      idName: "daily_habit",
      content: {
        headline: "Daily Habits",
        description: "Vanilla JS",
      },
      headline: {
        name: "Daily Habits",
        description: "Simple habit tracker — no frameworks, just JS",
      },
      info: [
        "Built during Hyper Island",
        "Pure vanilla JS — no React, no libraries, just the DOM",
        "Custom calendar logic written by hand",
      ],
      learnings: [
        "Working with Git in a team for the first time",
        "Writing complex UI logic without a framework",
        "Collaborating and splitting work with other developers",
      ],
      imgName: "dailyhabits.gif",
      links: {
        github: "https://github.com/kol845/Habit-Tracker",
        website: "https://kol845.github.io/Habit-Tracker/",
      },
    },
    {
      name: "Stock Alert",
      idName: "alert",
      content: {
        headline: "Stock Alert",
        description: "React Native, Python Flask backend",
      },
      headline: {
        name: "Stock Alert",
        description: "Get notified when a stock hits your price — tired of checking manually",
      },
      info: [
        "Built in 2020 on my own time",
        "First full mobile app I built with a real backend and login",
        "React Native frontend, Python Flask + SQLite backend",
      ],
      learnings: [
        "React Native from scratch",
        "Building and deploying a Flask backend",
        "User auth — registration, login, sessions",
        "Connecting a mobile app to a real API",
      ],
      imgName: "",
      links: {
        github: "https://github.com/kol845/alert",
      },
    },
  ],
}
